declare const $: any;

export function adjustTableButtonStyle(node: Node, config: { [p: string]: unknown }): void {
  $(node).removeClass();
  $(node).addClass('btn btn-primary');
  $(node).empty();
  $(node).text(config.text);
}
